import React, { useState, useEffect } from "react";
import { useMutation, useLazyQuery, useQuery } from "@apollo/client";
import { FIND_USER, EDIT_PASSWORD, DECRYPT_CODE, GET_USERPASSCODE } from "../queries";
import { TextField, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
import bgImage from "assets/images/strategia.jpg";
//import {useTranslation} from "react-i18next"
/*
import {useTranslation} from "react-i18next"
const [t, i18n] = useTranslation("common")
{t("headers.agendas")}
*/
import ReCAPTCHA from "react-google-recaptcha";
import { useParams } from "react-router-dom";
//import { LensTwoTone } from "@mui/icons-material"
import bcryptjs from "bcryptjs";
//import { set } from "lodash";
/* eslint-disable react/prop-types */
const NewPassword = ({ setError }) => {
  const [t] = useTranslation("common");
  //const [t, i18n] = useTranslation("common");
  const [codea, setCodea] = useState("");
  const [code, setCode] = useState("");
  //console.log(setCode);
  //const [dbcode, setDbcode] = useState("");
  const [codeok, setCodeok] = useState(false);
  const [verificationok, setVerificationok] = useState(false);
  const [codesubmitted, setCodesubmitted] = useState(false);
  const [verificationsubmitted, setVerificationsubmitted] = useState(false);
  const [password, setPass] = useState("");
  const [repass, setRepass] = useState("");
  const [email, setEmail] = useState("");
  const [useremail, setUseremail] = useState("");
  //const [pvm, setPvm] = useState("");
  //const [accepted, setAccepted] = useState(false)
  //const history = useHistory();
  //const bcryptjs = require("bcryptjs");
  const [getPerson] = useLazyQuery(FIND_USER);
  // eslint-disable-next-line
  //const [person, setPerson] = useState(null);
  // eslint-disable-next-line
  const [token, setTokeni] = useState("");
  //const [dbcodea, setDbcodea] = useState("");
  // eslint-disable-next-line
  const [dbcodeadecr, setDbcodeadecr] = useState("");
  const [verified, setVerified] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  // eslint-disable-next-line
  const [executing, setExecuting] = useState(false);
  //const [verifieda, setVerifieda] = useState(false);
  //const [submitteda, setSubmitteda] = useState(false);
  //const [executinga, setExecutinga] = useState(false);
  const [time, setTime] = useState(false);
  //const [datetim, setDatetim] = useState("");
  //const [decrcode, setDecrcode] = useState("");
  //const [diff, setDiff] = useState("");
  //let decryptCode = "";
  //if (codea !== "") {
  const decryptCode = useQuery(DECRYPT_CODE, {
    variables: { code: codea },
  });
  //}
  //const decryptDbcode = useQuery(DECRYPT_CODE, {
  //variables: { code: dbcode },
  //});
  //const [getUserpasscode] = useLazyQuery(GET_USERPASSCODE)

  const getUsercode = useQuery(GET_USERPASSCODE, {
    variables: { email },
  });
  //ensin luetaan id-parametri
  const id = useParams().id;
  function onChange(value) {
    //console.log("Captcha value:", value);
    setTokeni(value);
    setVerified(!verified);
  }
  // eslint-disable-next-line
  const showPerson = (email) => {    
    getPerson({
      variables: { emailToSearch: email },
    });
  };
  //
  useEffect(() => {
    //console.log(id);
    if (id !== undefined) {
      setCodea(id);
      //console.log(id);
    }
  }, [id]);
  //puretaan urlin id emailiksi ja ajaksi
  /*useEffect(() => {
    const koodi = decryptCode;
    setDecrcode(koodi);
  }, [codea, decryptCode]);
  /*
  //jaetaan url ajaksi ja emailiksi
  useEffect(() => {
    //console.log(decrcode);
    if (decrcode.data !== undefined) {
      const erotettu = decrcode.data.decryptCode.message.split("|||||");
      setDiff(erotettu);
    }
  }, [decrcode]);
  //tallennetaan email ja aika
  useEffect(() => {
    //console.log(diff);
    if (diff.length === 2) {
      setEmail(diff[0]);
      setDatetim(diff[1]);
    }
  }, [diff]);
  //tarkastetaan aika
  useEffect(() => {
    //console.log(datetim);
    if (datetim !== "") {
      const aika = Date.now();
      const timeurl = Date.parse(datetim);
      const expiring = timeurl + 60 * 60 * 1000;
      //const pvm = new Date(aika);
      //console.log("aika: " + aika.toString());
      //console.log("expiring: " + expiring.toString());
      //console.log(datetim);

      if (aika < expiring) {
        setTime(true);
      }
    }
  }, [datetim]);
  /*
  //dekryptataan kannan koodi
  useEffect(() => {
    if(dbcode!==""){
      //console.log(dbcode);
      let decdbcode = decryptDbcode
      //console.log(decdbcode);
      if(decdbcode.data!==undefined){
        //console.log(decdbcode);
        setDbcodeadecr(decdbcode.data.decryptCode.message);
      }
    }
  }, [dbcode, decryptDbcode])
*/
  //tarkastetaan täsmäävätkö koodit
  /*useEffect(() => {
    if (code === dbcode && code !== "") {
      setCodeok(true);
    }
  }, [dbcodeadecr, code, dbcode]);*/
  const [editPassword] = useMutation(EDIT_PASSWORD, {
    onError: (error) => {
      setError(error);
      //setError(error.graphQLErrors[0].message);
    },
  });
  // eslint-disable-next-line
  const submitcode= async (event) => {
    event.preventDefault();
    setCodesubmitted(true);
    let koodi = await decryptCode;
    //console.log(koodi);
    if (koodi.data !== undefined) {
      const erotettu = koodi.data.decryptCode.message.split("|||||");
      //console.log(erotettu);
      if (erotettu.length === 2) {
        setEmail(erotettu[0]);
        if (useremail === erotettu[0]) {
          if (erotettu[1] !== "") {
            const aika = Date.now();
            const timeurl = Date.parse(erotettu[1]);
            const expiring = timeurl + 60 * 60 * 1000;
            //const pvm = new Date(aika);
            //console.log("aika: " + aika.toString());
            //console.log("expiring: " + expiring.toString());
            //console.log(erotettu[1]);
            if (aika < expiring) {
              setTime(true);
            }
          }
        }
      }
    }
  };
  /*
  //dekryptataan kannan koodi
  useEffect(() => {
    if(dbcode!==""){
      //console.log(dbcode);
      let decdbcode = decryptDbcode
      //console.log(decdbcode);
      if(decdbcode.data!==undefined){
        //console.log(decdbcode);
        setDbcodeadecr(decdbcode.data.decryptCode.message);
      }
    //TÄHÄN dbcodea purkaminen ja sen jälkeen vertaaminen code===dbcodeadecr
    //onLogin("oleppani");
    //history.push("/");
    //haetaan kannan koodi
    //console.log("käyttäjän syöttämä koodi: " + codea);
    //console.log("time: " + time);
    //console.log("email: " + email);
    let codedb = await getUsercode;
    //console.log(codedb.data.getUserpasscode.message);
    await setDbcode(codedb.data.getUserpasscode.message);
  };
  */
  const submitverification = async (event) => {
    event.preventDefault();
    setVerificationsubmitted(true);
    let dbcodea = await getUsercode;
    //console.log(dbcodea);
    if (dbcodea.data !== undefined) {
      //setDbcode(dbcodea.data.getUserpasscode.message);
      //let dec = await decryptDbcode;
      ////console.log(dec);
      //if (dec.data !== undefined) {
      ////console.log(dec);
      //console.log(code);
      if (code === dbcodea.data.getUserpasscode.message && code !== "") {
        //console.log(dbcodea.data.getUserpasscode.message);
        setCodeok(true);
        setVerificationok(true);
        setVerified(false);
      }
      //}
    }
    ////console.log(verificationsubmitted);
    //TÄHÄN dbcodea purkaminen ja sen jälkeen vertaaminen code===dbcodeadecr
    //onLogin("oleppani");
    //history.push("/");
    //haetaan kannan koodi
    //let codedb = await getUsercode;
    ////console.log(codedb.data.getUserpasscode.message);
    //await setDbcode(codedb.data.getUserpasscode.message);
  };
  const submit = async (event) => {
    event.preventDefault();
    if (password === repass) {
      //const saltRounds = 17
      //const aika = Date.now();
      //const pvm = new Date(aika);
      var salt = bcryptjs.genSaltSync(12);
      const passwordhash = await bcryptjs.hash(password, salt);
      //console.log(passwordhash);
      /*const user = new User({
        username: body.username,
        name: body.name,
        passwordHash,
      });
      const savedUser = await user.save();
      response.json(savedUser);
      */
      //const passwordhash = password
      //const getCode = async () => {
      //    return get
      //}
      editPassword({
        variables: { email, passwordhash },
      });
      //const saltRounds = 17
      //const passwordhash = await bcryptjs.hash(password, saltRounds);
      //const passwordhash=password
      //var salt = bcryptjs.genSaltSync(12);
      //const passwordhash = await bcryptjs.hash(password, salt);
      ////console.log(passwordhash)
      setSubmitted(true);
      //onLogin("oleppani");
      //history.push("/");
    } else {
      window.confirm(t("common.passwordmismatch"));
    }
  };
  if (!codesubmitted) {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 500px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="body1"
                color="dark"
                textAlign="center"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                <form onSubmit={submitcode}>
                  <h3>{t("headers.newpassword")}</h3>
                  <div>
                    {t("common.code")}
                    <TextField value={codea} onChange={({ target }) => setCodea(target.value)} />
                  </div>
                  <div>
                    {t("common.email")}
                    <TextField
                      value={useremail}
                      onChange={({ target }) => setUseremail(target.value)}
                    />
                  </div>
                  <br />
                  <div>
                    <ReCAPTCHA
                      sitekey="6Lf6wLIaAAAAAORH1jwBkpv1NzwvaBYa9mpn39GP"
                      onChange={onChange}
                    />
                  </div>
                  <br />
                  <Button
                    style={{ backgroundColor: "#07575B", color: "#C4DFE6", fontSize: "14px" }}
                    type="submit"
                    disabled={!verified}
                  >
                    {t("common.send")}
                  </Button>
                  <br />
                  <br />
                  <a href="/register">{t("common.registration")}</a>
                  <br />
                  <br />
                  <a href="/">{t("common.tostart")}</a>
                </form>
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  }
  if (time && codesubmitted && !verificationsubmitted) {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 500px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="body1"
                color="dark"
                textAlign="center"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                <form onSubmit={submitverification}>
                  <h3>{t("headers.newpassword")}</h3>
                  <div>
                    {t("common.verification")}
                    <TextField value={code} onChange={({ target }) => setCode(target.value)} />
                  </div>
                  <br />
                  <Button
                    style={{ backgroundColor: "#07575B", color: "#C4DFE6", fontSize: "14px" }}
                    type="submit"
                  >
                    {t("common.send")}
                  </Button>
                  <br />
                  <br />
                  <a href="/register">{t("common.registration")}</a>
                  <br />
                  <br />
                  <a href="/">{t("common.tostart")}</a>
                </form>
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  }
  if (!time) {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 500px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="body1"
                color="dark"
                textAlign="center"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                <h2>{t("headers.newpassword")}</h2>
                {t("common.oldlink")}
                <br />
                <br />
                <a href="/">{t("common.tostart")}</a>
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  }
  if (codeok && verificationok && !submitted) {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 500px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="body1"
                color="dark"
                textAlign="center"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                <form onSubmit={submit}>
                  <h3>{t("headers.newpassword")}</h3>
                  <div>
                    {t("common.password")}
                    <TextField
                      value={password}
                      type="password"
                      onChange={({ target }) => setPass(target.value)}
                    />
                    <br />
                    <br />
                    {t("common.repassword")}
                    <TextField
                      value={repass}
                      type="password"
                      onChange={({ target }) => setRepass(target.value)}
                    />
                  </div>
                  <br />
                  <div>
                    <ReCAPTCHA
                      sitekey="6Lf6wLIaAAAAAORH1jwBkpv1NzwvaBYa9mpn39GP"
                      onChange={onChange}
                    />
                  </div>
                  <Button
                    style={{ backgroundColor: "#07575B", color: "#C4DFE6", fontSize: "14px" }}
                    type="submit"
                    disabled={!verified}
                  >
                    {t("common.send")}
                  </Button>
                  <br />
                  <br />
                  <a href="/register">{t("common.registration")}</a>
                  <br />
                  <br />
                  <a href="/">{t("common.tostart")}</a>
                </form>
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  }
  if (submitted) {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 500px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="body1"
                color="dark"
                textAlign="center"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                <h2>{t("headers.newpassword")}</h2>
                {t("common.formok")}
                <br />
                <br />
                <a href="/">{t("common.tostart")}</a>
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  }
  if (!codeok) {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 500px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="body1"
                color="dark"
                textAlign="center"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                <h2>{t("headers.newpassword")}</h2>
                {t("common.wrongcode")}
                <br />
                <br />
                <a href="/">{t("common.tostart")}</a>
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  }
  return (
    <>
      <MKBox
        minHeight="23vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "2500px 500px",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      />
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="body1"
              color="dark"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              <h2>{t("headers.newpassword")}</h2>
              {t("common.failed")}
              <br />
              <br />
              <a href="/">{t("common.tostart")}</a>
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
    </>
  );
};

export default NewPassword;
